import { render, staticRenderFns } from "./BSimHistoryCard.vue?vue&type=template&id=756161dc&"
import script from "./BSimHistoryCard.vue?vue&type=script&lang=js&"
export * from "./BSimHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./BSimHistoryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports